
export const titles = {
    add: "Add City",
    edit: "Edit City",
}